// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_e5-0";